import { useEffect, useState } from "react";
import useGet from "./useGet";
import { VALIDATE_NIN_API } from "../../utils/apis";

export default function useNin(form: any, updateFormValues: any) {
  const { loadData: checkNin, data: ninUser, success, loading } = useGet();
  const [ninError, setNinError] = useState<any>(null);

  useEffect(() => {
    setNinError(null);
    if (form?.nin) {
      if (form?.nin?.length == 14) {
        checkNin({
          api: VALIDATE_NIN_API,
          params: { nin: form?.nin.toUpperCase() },
        });
      } else {
        updateFormValues({
          first_name: "",
          last_name: "",
          other_name: "",
        });
      }
    }
  }, [form?.nin]);

  useEffect(() => {
    if (ninUser?.isValid) {
      updateFormValues({
        first_name: ninUser?.personGivenNames,
        last_name: ninUser?.personSurname,
        other_name: ninUser?.personOtherNames,
      });
    } else if (ninUser?.isValid == false) {
      setNinError({ nin: "NIN is not valid", notSubmit: true });
    }
  }, [ninUser]);

  return { loading, ninError, success };
}
